<template>
  <div>
    <PrivacyWarningDialog v-model="isPrivacyWarningDialogVisible" />

    <v-menu :close-on-content-click="false" left>
      <template v-slot:activator="{ on }">
        <v-btn color="mainButtons" outlined v-on="on">
          {{ $t('general.menu') }}
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list color="kbWhite">
        <v-list-item class="kbDarkBlueText--text"
                     :disabled="companyBlocked"
                     @click="showNewUserDialog()">
          <v-list-item-action class="mr-4">
            <v-icon color="kbPurple">mdi-account-plus</v-icon>
          </v-list-item-action>
          <v-list-item-title class="kbDarkBlueText--text">
            {{ $t('general.createPerson') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          class="kbDarkBlueText--text"
          v-if="isCloudTask ||
                (appModules.includes('export-permission') &&
                administratorRoles.includes('ROLE_RECORD_EXPORT')) ||
                userType === 'superadmin'"
          @click="openPrivacyWarningDialog()"
        >
          <v-list-item-action class="mr-4">
            <v-icon color="kbPurple">mdi-file-import-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title class="kbDarkBlueText--text">
            {{ $t('general.export') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="kbDarkBlueText--text"
                     :disabled="companyBlocked"
                     @click="showImporter()">
          <v-list-item-action class="mr-4">
            <v-icon color="kbPurple">mdi-file-export-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title class="kbDarkBlueText--text">
            {{ $t('general.import') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item-action class="mr-4">
              <v-icon color="kbPurple">mdi-account-multiple-plus</v-icon>
            </v-list-item-action>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('general.invitations') }}
            </v-list-item-title>
          </template>

          <v-list color="kbLight">
            <v-list-item @click="showInviteUserDialog()">
              <v-list-item-title class="kbDarkBlueText--text pl-11">
                {{ $t('general.invite') }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="showGuestsDialog()">
              <v-list-item-title class="kbDarkBlueText--text pl-11">
                {{ $t('general.seeGuests') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PrivacyWarningDialog from '@/pages/App/People/dialogs/PrivacyWarningDialog'
export default {
  components: { PrivacyWarningDialog },
  computed: {
    ...mapGetters([
      'administratorRoles',
      'appModules',
      'appUuid',
      'companyPaymentState',
      'companyIsMonthlyBilling',
      'companyUuid',
      'userType'
    ]),
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask
    }),
    companyBlocked () {
      return (
        this.companyPaymentState === 'block' &&
        !this.companyIsMonthlyBilling
      )
    }
  },
  data () {
    return {
      isPrivacyWarningDialogVisible: false
    }
  },
  methods: {
    openPrivacyWarningDialog () {
      this.isPrivacyWarningDialogVisible = true
    },
    showGuestsDialog () {
      this.$emit('showGuestsDialog')
    },
    showImporter () {
      this.$emit('showImporter')
    },
    showInviteUserDialog () {
      this.$emit('showInviteUserDialog')
    },
    showNewUserDialog () {
      this.$emit('showNewUserDialog')
    }
  }
}
</script>
